window.gMapsLoaded = false;
window.gMapsCallback = function () {
    window.gMapsLoaded = true;
    $(window).trigger('gMapsLoaded');
}
window.loadGoogleMaps = function (token) {
    if (gMapsLoaded) return window.gMapsCallback();
    var script_tag = document.createElement('script');
    script_tag.setAttribute("type", "text/javascript");
    script_tag.setAttribute("src", `//maps.google.com/maps/api/js?key=${token}&callback=gMapsCallback`);
    (document.getElementsByTagName("head")[0] || document.documentElement).appendChild(script_tag);
}
const googleMap = () => {

    const container = $('#googleMap');
    const token = container.data('token');
    const coordinates = container.data('coordinates').split(",");

    function initialize() {
        const myLatLng = new google.maps.LatLng(coordinates[0], coordinates[1]);

        const mapOptions = {
            zoom: 16,
            center: myLatLng,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            disableDefaultUI: true
        };

        const map = new google.maps.Map(document.getElementById('googleMap'), mapOptions);

        const marker = new google.maps.Marker({
            position: myLatLng,
            map: map,
            title: 'ProLease'
        });
    }
    $(window).bind('gMapsLoaded', initialize);
    window.loadGoogleMaps(token);
};

export default googleMap;


// WEBPACK FOOTER //
// ./resources/js/modules/map.js